import LegalPlugin from './legal';
import NavigationPlugin from './navigation';
import SelfContainedPlugin from './selfContained';
import Toolbar from './toolbar/index';
export default function pluginFactory(name) {
    switch (name) {
        case 'navigation':
            return new NavigationPlugin();
        case 'toolbar':
            return new Toolbar();
        case 'self_contained':
            return new SelfContainedPlugin();
        case 'legal':
            return new LegalPlugin();
        default:
            return null;
    }
}
